// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see AppSessionInitiateStartEvent
 */
export var AppSessionInitiateStart = function (_a) {
    var reason = _a.reason;
    return ({
        name: "AppSession Initiate Start",
        parameters: {
            cdf_entity: "AppSession",
            cdf_action: "Initiate",
            reason: reason !== undefined && reason !== null ? reason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AppSessionInitiateSucceedEvent
 */
export var AppSessionInitiateSucceed = function () { return ({
    name: "AppSession Initiate Succeed",
    parameters: {
        cdf_entity: "AppSession",
        cdf_action: "Initiate",
    }
}); };
/**
 * @see AppSessionInitiateFailEvent
 */
export var AppSessionInitiateFail = function (_a) {
    var httpErrorCode = _a.httpErrorCode, isNetworkFailure = _a.isNetworkFailure;
    return ({
        name: "AppSession Initiate Fail",
        parameters: {
            cdf_entity: "AppSession",
            cdf_action: "Initiate",
            http_error_code: httpErrorCode !== undefined && httpErrorCode !== null ? httpErrorCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_network_failure: isNetworkFailure !== undefined && isNetworkFailure !== null ? isNetworkFailure.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
